import { colors } from '@vds-core/theme';
export var getBackgroundColor = function getBackgroundColor(props) {
  var backgroundColor = props.backgroundColor,
      inverted = props.inverted;
  var backColor = backgroundColor;

  if (!backColor) {
    backColor = inverted ? colors.black : colors.white;
  }

  return backColor;
};